import { queueFont } from "../queueFont";

export function ModeLegend() {
  return (
    <div className={`${queueFont} fixed bottom-3 left-3 max-w-[360px] text-[11px] leading-snug text-slate-400`}>
      Demo routes: <strong>/room/1</strong> single · <strong>/room/all</strong> all ·{" "}
      <strong>/room/custom</strong> pick rooms · <strong>?fix=1</strong> max 8/page
    </div>
  );
}
